module.exports = __webpack_public_path__ + "static/GH17-8eaaae7540fd74103dca1abd36a68b76.jpg";